import { escapeRegExp } from "lodash-es"

const ELLIPSIS = "[...]"

export function useSearchFormatter(query: MaybeRefOrGetter<string>) {
  const { $parseStringToDocument } = useNuxtApp()

  // TODO: Would prefer this to be a computed property, but as long as we have a global flag + using test, we need to recreate the regex every time.
  function createRegex() {
    return new RegExp(escapeRegExp(toValue(query)), "gi")
  }

  function mark(input: string): string {
    const q = toValue(query)
    if (!q || q === "*")
      return input

    return input.replaceAll(createRegex(), "<mark class='bg-[--theme-lighter]'>$&</mark>")
  }

  return {
    title(input: string | null | undefined): string {
      if (!input?.trim())
        return ""

      return mark(input)
    },

    description(input: string | null | undefined): string {
      if (!input?.trim())
        return ""

      const safeInput = $parseStringToDocument(input, ["remove_title", "tts"]).body.textContent

      if (!safeInput?.trim())
        return ""

      if (!createRegex().test(safeInput) || toValue(query).length < 1) {
        return `${safeInput.split(".").slice(0, 2).join(".")}. ${ELLIPSIS}`
      }

      const matches = safeInput
        .split(".")
        .filter(sent => createRegex().test(sent))
        .join(`. ${ELLIPSIS} `)

      return [
        ELLIPSIS,
        `${mark(matches)}.`,
        ELLIPSIS,
      ].join(" ")
    },
  }
}
